var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterGrpOffIconHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "comp-table-filter-button",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 40,
    height: 40,
    rx: 4,
    fill: "rgba(34,124,157,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grp-filter-off",
    transform: "translate(-112 -248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "filter_alt_FILL0_wght400_GRAD0_opsz48",
    d: "M9.29,8a1.2,1.2,0,0,0-1.137.713,1.155,1.155,0,0,0,.147,1.35L17.065,21.5v9a1.49,1.49,0,0,0,.422,1.069A1.424,1.424,0,0,0,18.532,32h2.934a1.424,1.424,0,0,0,1.045-.431,1.49,1.49,0,0,0,.422-1.069v-.73A6.974,6.974,0,0,1,17.781,23a7.126,7.126,0,0,1,.781-3.211L11.2,10.25H28.8l-4.455,5.77q.14-.013.281-.019a6.712,6.712,0,0,1,2.228.383l4.845-6.32a1.155,1.155,0,0,0,.147-1.35A1.2,1.2,0,0,0,30.711,8Z",
    transform: "translate(112 248)",
    fill: "#227c9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(131.464 266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "search_off_FILL0_wght400_GRAD0_opsz48",
    d: "M9,35a4.811,4.811,0,0,1-3.526-1.474,4.956,4.956,0,0,1,0-7.053A4.811,4.811,0,0,1,9,25a4.811,4.811,0,0,1,3.526,1.474,4.956,4.956,0,0,1,0,7.053A4.811,4.811,0,0,1,9,35ZM6.868,32.158a.445.445,0,0,0,.632,0l1.5-1.5,1.5,1.5a.357.357,0,0,0,.289.118.459.459,0,0,0,.289-.145.414.414,0,0,0,0-.6l-1.5-1.5,1.579-1.579a.372.372,0,0,0,.118-.3.47.47,0,0,0-.145-.3.384.384,0,0,0-.579,0L9,29.4,7.447,27.842a.384.384,0,0,0-.579,0,.414.414,0,0,0,0,.6L8.4,30,6.868,31.526a.445.445,0,0,0,0,.632Z",
    transform: "translate(-4 -25)",
    fill: "#c4314b"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterGrpOffIconHover);
export default __webpack_public_path__ + "static/media/Filter-grp-off-icon-hover.06dab3a3a846f798090613a06d20b0df.svg";
export { ForwardRef as ReactComponent };